import _isNil from "lodash/isNil";
import createMemoizedSelector from '../createMemoizedSelector';
import getPairs from './getPairs';
import { getEmptySublibrarySelections, getAutoDetectedSublibrarySelections } from '../../../utils/secondary-analysis/fastqMatcher';
var getAutoDetectedSublibrarySelectionsSelector = function getAutoDetectedSublibrarySelectionsSelector() {
  return function (analysisState, pairs) {
    if (_isNil(analysisState) || _isNil(pairs) || _isNil(analysisState.numOfSublibraries)) {
      return getEmptySublibrarySelections();
    }
    var numOfSublibraries = analysisState.numOfSublibraries,
      pairedWt = analysisState.pairedWt,
      files = analysisState.files;
    return getAutoDetectedSublibrarySelections(pairs, files === null || files === void 0 ? void 0 : files.data, files === null || files === void 0 ? void 0 : files.sublibraries, numOfSublibraries, pairedWt);
  };
};
export default createMemoizedSelector(getAutoDetectedSublibrarySelectionsSelector, {
  inputSelectors: [{
    func: function func(secondaryAnalysisId) {
      return function (state) {
        return state[secondaryAnalysisId];
      };
    },
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }, {
    func: getPairs,
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }]
});